/**
 * Get the last part of an url path
 * @param {string} url - url path
 * @param {number} offset - the last offset index
 * @return {string} the fragment we want to retrive
 *
 * @example
 * getLastUrlFragment('foo/bar/baz/') // 'baz'
 *
 * @example
 * getLastUrlFragment('foo/bar/baz/', 1) // 'bar'
 *
 * @example
 * getLastUrlFragment('foo/bar/baz/', 2) // 'foo'
 *
 * @example
 * getLastUrlFragment('foo/bar/baz/', 3) // ''
 */
export default function getLastUrlFragment(url, offset = 0) {
    const fragments = url.split('/').filter(Boolean);
    const index = fragments.length - (1 + offset);

    return fragments[index] || '';
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/get-last-url-fragment.js